import React, { Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import '../../styles/balanco.scss';

const Breadcrumb = ({ items }) => {
  
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {items.map((item, index) => (
          <li key={index} className={`breadcrumb-item ${item.active ? 'active' : ''}`}>
            {item.active ? (
              <span>{item.label}</span>
            ) : (
              <a href={item.link}>{item.label}</a>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
